import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, NavigationBehaviorOptions, Router } from '@angular/router';
import { Campagne } from '@core/models/campagne.model';
import { navPaths } from '@core/models/support.model';
import { CampagneTypologieService } from '@core/services';
import { GlobalDataService } from '@core/services/global-data.service';
import { ProduitService } from '@core/services/produit.service';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'app-campagne-typologie-encre',
  templateUrl: './campagne-typologie-encre.component.html',
  styleUrls: ['./campagne-typologie-encre.component.scss']
})
export class CampagneTypologieEncreComponent implements OnInit {
  typologie: string = "autre";

  navigationOption: NavigationBehaviorOptions = {};

  constructor(
    private router: Router,
    private readonly activatedRoute: ActivatedRoute,    
    public _GlobalDataService: GlobalDataService,
    public _CampagneTypologieService: CampagneTypologieService,
  ) {

    const routeState = this.router.getCurrentNavigation()?.extras?.state || history.state;
    const typologieFromState = routeState?.['typologie'];
    if (typologieFromState === 'autre' || typologieFromState === 'lettre' || typologieFromState === 'enveloppe') {
      this.typologie = typologieFromState;
    }
  }

  ngOnInit() {
  }

  gotoTypologieSelection(): void {
    console.log('gotoTypologieSelection');
    this._CampagneTypologieService.navigate(navPaths.selection, this.activatedRoute.parent as ActivatedRoute, this.navigationOption);
  } 

}
